import type { LucideIcon } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { cn } from '~/shared/lib/utils'

interface FeatureCardProps {
  icon: LucideIcon
  title: string
  description: string
  underDevelopment?: boolean
  onClick?: () => void
}

export function FeatureCard({
  icon: Icon,
  title,
  description,
  underDevelopment = false,
  onClick,
}: FeatureCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group relative flex cursor-pointer flex-col items-start gap-4 overflow-hidden rounded-xl border bg-card p-6 text-left text-card-foreground beacon-interactive',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50',
      )}
    >
      {underDevelopment && (
        <span className="pointer-events-none absolute top-3 right-3 select-none rounded-full bg-muted px-2 py-0.5 font-medium text-[10px] text-muted-foreground uppercase tracking-wide">
          {m.underDevelopment()}
        </span>
      )}
      <span className="relative flex h-12 w-12 items-center justify-center rounded-lg bg-orange-50 text-orange-600 transition-transform duration-300 ease-spring group-hover:-translate-y-0.5 group-hover:scale-105 dark:bg-orange-950 dark:text-orange-400">
        <Icon className="h-6 w-6" />
      </span>
      <div className="relative space-y-1.5">
        <h3 className="font-semibold leading-none tracking-tight">{title}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </button>
  )
}
